// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logo":"Header_logo__shVBB","tel":"Header_tel__6LDFX","address":"Header_address__2w7Ap"};